import moment from 'moment'
export default [
  {
    type: 'date',
    property: 'startDate',
    props: {
      label: 'Fecha de inicio'
    },
    queryFunction: function (val) {
      let _query
      if (!Array.isArray(val)) {
        _query = {
          'filters[whereBetween][startDate]': val ? [moment(val).format('YYYY-MM-DD'), moment(val).add(1, 'day').format('YYYY-MM-DD')] : null
        }
      } else {
        _query = {
          'filters[whereBetween][startDate]': [moment(val[0]).format('YYYY-MM-DD'), moment(val[1]).format('YYYY-MM-DD')]
        }
      }
      return _query
    }
  },
  {
    type: 'date',
    property: 'endDate',
    props: {
      label: 'Fecha de culmunación'
    },
    queryFunction: function (val) {
      let _query
      if (!Array.isArray(val)) {
        _query = {
          'filters[whereBetween][endDate]': val ? [moment(val).format('YYYY-MM-DD'), moment(val).add(1, 'day').format('YYYY-MM-DD')] : null
        }
      } else {
        _query = {
          'filters[whereBetween][endDate]': [moment(val[0]).format('YYYY-MM-DD'), moment(val[1]).format('YYYY-MM-DD')]
        }
      }
      return _query
    }
  }
]



// WEBPACK FOOTER //
// ./src/utilis/filters-campaign.js